// extracted by mini-css-extract-plugin
module.exports = {"policyButton":"Signup_policyButton__2Rr1v","policyTooltip":"Signup_policyTooltip__2C0Ch","show":"Signup_show__3zAQ4","closeButton":"Signup_closeButton__1Sw6n"};